"use client";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { TranslationsListType } from "@/lib/types";
import {
  useQuranOptions,
  useQuranStateUpdate,
} from "@/app/providers/QuranContextProvider";
import { ChangeEvent, useMemo, useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./accordion";
import { JuzIcon } from "@/app/icons/icon-juz";

export default function TranslationListTags({
  translationsList,
}: {
  translationsList: Array<TranslationsListType[]>;
}) {
  const { activeTranslations } = useQuranOptions();
  const { setActiveTranslations } = useQuranStateUpdate();
  const [selected, setSelected] = useState(activeTranslations);
  const [inputText, setInputText] = useState("");

  const handleTranslationclick = ({
    id,
    name,
    language,
  }: TranslationsListType) => {
    if (activeTranslations.length == 1 && id == activeTranslations[0].id)
      return;

    let selectedTranslation = [...activeTranslations];
    const tIds = selected.map((e) => e.id);

    if (tIds.indexOf(id) < 0) {
      selectedTranslation.push({ id, name, language });
    } else selectedTranslation = selectedTranslation.filter((t) => t.id != id);

    setActiveTranslations(selectedTranslation);
    setSelected(selectedTranslation);
  };

  const handleTranslationFilter = (event: ChangeEvent<HTMLInputElement>) => {
    setInputText(event.target.value);
  };

  const filteredTranslationsList = useMemo(() => {
    return translationsList
      .map((translations) =>
        translations.filter(
          (translation) =>
            inputText === "" ||
            translation.name.toLowerCase().includes(inputText) ||
            translation.language.toLowerCase().includes(inputText),
        ),
      )
      .filter((translations) => translations.length > 0);
  }, [inputText, translationsList]);

  return (
    <div className="mt-3">
      <Input
        className="mb-2"
        placeholder="Filter Translations"
        onChange={(e) => handleTranslationFilter(e)}
        aria-label="Filter Translations"
      />
      <Accordion type="multiple" className="AccordionDiv">
        {filteredTranslationsList.map((trans) => {
          const tIds = selected.map((e) => e.id);
          return (
            <AccordionItem
              key={trans[0].language}
              value={trans[0].language}
              className="data-[state=open]"
            >
              <AccordionTrigger className="hover:bg-primary/10 p-0 rounded-md h-10">
                <div className="flex flex-row wi-full">
                  <JuzIcon className="h-5 w-5 text-primary mr-2" />
                  {trans[0].language}
                </div>
              </AccordionTrigger>
              <AccordionContent>
                {trans.map((e) => {
                  const isActive = tIds.indexOf(e.id) < 0 ? false : true;
                  return (
                    <div
                      key={e.name + e.id}
                      className=" flex flex-row pt-3 justify-between items-center w-full"
                      data-tid={e.id}
                      data-lang={e.language}
                      onClick={() =>
                        handleTranslationclick({
                          id: e.id,
                          name: e.name,
                          language: e.language,
                        })
                      }
                      data-name={e.name}
                    >
                      <Label
                        htmlFor={`trans-${e.id}`}
                        data-lang={e.language}
                        data-name={e.name}
                      >
                        {e.name}
                      </Label>
                      <Switch
                        id={`trans-${e.id}`}
                        data-tid={e.id}
                        data-lang={e.language}
                        data-name={e.name}
                        checked={isActive ? true : false}
                      />
                    </div>
                  );
                })}
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
}
